<template>
  <div class="container">
    <div class="row">
      <div class="col-12 add-margin-top-4-rem ">
          <div class="row justify-content-center align-items-center add-margin-bottom">
            <div class="col col-md-6 col-xs-12 background-white login">
              <p class="text-danger" v-if="loginFailed">Login Failed</p>
              <h5><strong>Field Assessment Tool Sign In</strong></h5>
              <p class='instructional-text'>This Field Assessment Tool requires you to sign in
                separately from the Community Assessor application. This sign-in will enable you
                to use this tool while offline.</p>
              <b-form-group
                id="input-group-1"
                label="Username:"
                label-for="username"
                description=""
              >
                <b-form-input
                  id="username"
                  v-model="form.userName"
                  type="email"
                  required
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="password"
                label="Password:"
                label-for="password"
                description=""
              >
                <b-form-input
                  type="password"
                  id="text-password"
                  v-model="form.password"
                  aria-describedby="password-help-block"
                ></b-form-input>
              </b-form-group>
              <b-button @click="signIn" type="submit" variant="sign-in">
                Sign In
              </b-button>
              <b-link class="forgot-password"
                :href="getForgotPasswordUrl()">Forgot Password?
              </b-link>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import axios from 'axios';
import helpers from '@/mixins/helpers';
import { createStore, del } from 'idb-keyval';

export default {
  name: 'LogIn',
  mixins: [helpers],
  components: {},
  data() {
    return {
      form: {
        userName: '',
        password: '',
      },
      loginFailed: false,
    };
  },
  computed: {
    ...mapState({
      communityAssessorUrl: (state) => state.config.communityAssessorUrl,
      wrapUrl: (state) => state.config.wrapUrl,
      loggedIn: (state) => state.loggedIn,
    }),
  },
  mounted() {
    this.$store.dispatch('fetchConfiguration').then(() => {
      this.$store.dispatch('refreshLoggedInStatus').then(() => {
        if (this.loggedIn) {
          this.$router.push({ name: 'home' });
        }
      });
    });

    // doing these here to cache the result to be used when offline
    // since LogIn is the first page we visit on the pwa
    this.$store.dispatch('fetchAssessmentCategories');
    this.$store.dispatch('fetchFireDepartments');

    window.addEventListener('keyup', (event) => {
      if (event.key !== undefined && event.key === 'Enter') {
        this.signIn();
      }
    });
  },
  methods: {
    getForgotPasswordUrl() {
      return `${this.wrapUrl}/Account/ForgotPassword`;
    },
    onEnter() {
      this.signIn();
    },
    signIn() {
      if (!navigator.onLine) {
        const message = 'You are not logged in and are offline. Please connect to the internet '
        + 'and sign in to use the Field Assessment Tool.';
        this.showOkModal(null, message);
      } else {
        this.loginFailed = false;
        window.btoa(':password');
        const vm = this;
        const userLoggedIn = this.form.userName;

        axios
          .get(`${vm.communityAssessorUrl}/BuildJwt`, {
            auth: {
              username: this.form.userName,
              password: this.form.password,
            },
            headers: {
              Accept: 'application/json', // needs to be set to avoid the wrap to redirect us to their Account/LogOn endpoint upon 401 failures
            },
          })
          .then((response) => {
            this.$store.dispatch('setNewTokenAndLoggedInStatus', { newToken: response.data, userLoggedIn })
              .then(() => {
                this.$router.push({ name: 'home' });
              });
          })
          .catch((exc) => {
            this.loginFailed = true;
            localStorage.removeItem('access_token');
            localStorage.removeItem('userLoggedIn');
            const customStore = createStore('fieldToolAccess', 'access');
            del('access_token', customStore);
            del('userLoggedIn', customStore);
            console.log(`error: ${exc}`);

            if (exc.toJSON().message.includes('Request failed with status code 401')) {
              const messageVNode = this.$createElement('div', {
                domProps: {
                  innerHTML: `Please ensure your account is active and you are using a valid username and password. Please go <a href="${this.wrapUrl}/MyAccount/Edit"> here</a> to manage your account.`,
                },
              });
              this.$bvModal.msgBoxOk([messageVNode], {
                title: 'Sign In Failed',
                centered: true,
              });
            }
          });
      }
    },
  },
};
</script>
